<script>
  function broadcast(componentName, eventName, params) {
    this.$children.forEach(child => {
      var name = child.$options.componentName;

      if (name === componentName) {
        child.$emit.apply(child, [eventName].concat(params));
      } else {
        broadcast.apply(child, [componentName, eventName].concat([params]));
      }
    });
  }

  let emitter = {
    methods: {
      dispatch(componentName, eventName, params) {
        var parent = this.$parent || this.$root;
        var name = parent.$options.componentName;

        while (parent && (!name || name !== componentName)) {
          parent = parent.$parent;

          if (parent) {
            name = parent.$options.componentName;
          }
        }
        if (parent) {
          parent.$emit.apply(parent, [eventName].concat(params));
        }
      },
      broadcast(componentName, eventName, params) {
        broadcast.call(this, componentName, eventName, params);
      }
    }
  };
  import sd from 'vue-text-mask'
  //TODO: не работает
  export default {
    mixins: [emitter],
    props: {
      value: {
        type: [String, Number],
        default: 0,
      },
      defaultCountry: {
        type: String,
        default: 'ru',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        val: '',
        f: false,
        old: '',
        country: 'ru',
        countries: [
          {
            name: 'ru',
            label: 'Россия',
            code: '7',
            mask: '+7 (xxx) xxx-xx-xx',
            regions: [8182, 8512, 3852, 3854, 4725, 4162, 8162, 4232, 4236, 8672, 8442, 8443, 8172, 3432, 3435, 3412, 3952, 8362, 8432, 3842, 3843, 8332, 8612, 3912, 8722, 8152, 8552, 8662, 4855, 4112, 4242, 3022, 8202, 3511, 8352, 4212, 3473, 3472, 8422, 3012, 3452, 3822, 8482, 8212, 3466, 3462, 8652, 8622, 8452, 8342, 8462, 8632, 8112, 4152, 8142, 3422, 8412, 3532, 3812, 8617, 8312],
            masks: [
              '+d (xxx) xxx-xx-xx',
              '+d (xxx) xxx-xx-xx',
              '+d (xxx) xxx-xx-xx',
              '+d (xxx) xxx-xx-xx',
              '+d (xxxx) xx-xx-xx',
            ]
          },
          {
            name: 'kz',
            label: 'Казахстан',
            code: '77',
            mask: '+7 (7xx) xxx-xx-xx'
          },
          {
            name: 'ua',
            label: 'Украина',
            code: '380',
            mask: '+380 (xx) xxx-xx-xx',
            regions: [0],
            masks: [
              '+380 (xx) xxx-xx-xx',
              '+380 (0xx) xxx-xx-xx',
            ]
          },
          {
            name: 'by',
            label: 'Беларусь',
            code: '375',
            mask: '+375 (xx) xxx-xx-xx',
          },
        ],
      }
    },
    methods: {
      get_masks(v) {
        let a = v.replace(/[^0-9]/gim, '');
        this.get_country(a);
        let text = '+dxxxxxxxxxxxxxx';

        this.countries.forEach(({name, code, mask, regions, masks}) => {
          if (name === this.country) {
            text = mask;
            if (regions) {
              regions.forEach(j => {
                let jj = '' + j;
                let b = code + jj;
                if (a.indexOf(b) === 0) {
                  text = masks[jj.length];
                }
              });
            }
          }
        });
        return this.generate(text);
      },
      generate(v) {
        let m = v.split('');
        let r = [];
        m.forEach(i => {
          switch (i) {
            case 'd':
              r.push(/[1-9]/);
              break;
            case 'x':
              r.push(/[0-9]/);
              break;
            case '0':
              r.push(/0/);
              break;
            case '1':
              r.push(/1/);
              break;
            case '2':
              r.push(/2/);
              break;
            case '3':
              r.push(/3/);
              break;
            case '4':
              r.push(/4/);
              break;
            case '5':
              r.push(/5/);
              break;
            case '6':
              r.push(/6/);
              break;
            case '7':
              r.push(/7/);
              break;
            case '8':
              r.push(/8/);
              break;
            case '9':
              r.push(/9/);
              break;
            default:
              r.push(i);
          }
        });
        return r;
      },
      change(e) {
        this.$emit('change', this.currentValue);
        this.$emit('input', this.currentValue);
        this.dispatch('ElFormItem', 'el.form.change', [this.currentValue]);
      },
      blur() {
        this.dispatch('ElFormItem', 'el.form.blur', [this.currentValue]);
      },
      handleCommand(v) {
        let val = '';
        this.countries.forEach(i => {
          if (i.name === v) val = i.code;
        });
        this.$emit('change', '');
        this.$emit('input', '');
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.$refs.input.updateValue(val)
          });
        });
      },
      get_country(a) {
        a = a ? a : this.val.replace(/[^0-9]/gim, '');
        let flag = '';
        this.countries.forEach(i => {
          if (a.indexOf(i.code) === 0) flag = i.name;
        });
        this.country = flag;
      },
    },
    computed: {
      currentValue() {
        let value = '';
        value = this.val.replace(/[^0-9]/gim, '');
        switch (this.country) {
          case 'ru':
          case 'kz':
            value = value.length === 11 ? value : '';
            break;
          case 'ua':
          case 'by':
            value = value.length >= 12 ? value : '';
            break;
          default:
            value = value ? value : '';
        }
        return value;
      },
    },
    watch: {
      value(v) {
        this.get_country();
        this.$refs.input.updateValue('' + v);
        this.$nextTick(() => {
          this.$refs.input.updateValue('' + v);
        });
      },
    },
    components: {},
    mounted() {
      if (!this.value) this.handleCommand(this.defaultCountry);
    },
    destroyed() {

    },
  }
</script>
<template>
  <div class="input-phone el-input el-input--mini">
    <el-dropdown class="input-phone__flags" trigger="click" @command="handleCommand">
      <div class="el-dropdown-link">
        <span v-show="country" class="flag" :class="['flag-'+country]"></span>
      </div>
      <el-dropdown-menu slot="dropdown" class="input-phone__dropdown">
        <el-dropdown-item v-for="item in countries" :command="item.name" :key="item.name">
          <span class="flag" :class="['flag-'+item.name]"></span> {{item.label}}
        </el-dropdown-item>
        <el-dropdown-item command="">
          Произвольный
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <masked-input
      type="text"
      @change="change"
      :value="val!=='0'?val:''"
      @input="val=$event"
      @blur="blur"
      :mask="get_masks"
      :guide="false"
      placeholderChar="_"
      ref="input"
      class="el-input__inner"
      :disabled="disabled">
    </masked-input>
  </div>
</template>
<style lang="scss">
  .input-phone {
    display: flex;
    &__flags {
      width: 40px;
      flex-shrink: 0;
      cursor: pointer;
      height: 28px;
      background: #fafafa;
      border-radius: 4px 0 0 4px;
      text-align: right;
      line-height: 26px;
      min-height: 28px;
      display: block;
      border-bottom: 1px solid;
      border-top: 1px solid;
      border-left: 1px solid;
      border-color: #dcdfe6;
      color: #333;
      font-size: 12px;
      .el-dropdown-link {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    &__dropdown {
      .el-dropdown-menu__item {
        display: flex;
      }
    }
    .el-input__inner {
      border-radius: 0 4px 4px 0;
    }
  }
</style>
